import PropTypes from 'prop-types';
import React from 'react';
import { ArrowRight } from 'react-bootstrap-icons';

import GroupLink from './group_link';

const ReadMoreLink = ({
	article_id,
	groups,
	label,
	marker_id,
	page,
	product_brand_id,
	product_id,
}) => {
	return (
		<section>
			<GroupLink
				article_id={article_id}
				groups={groups}
				marker_id={marker_id}
				page={page}
				product_brand_id={product_brand_id}
				product_id={product_id}
			>
				<div className="row align-items-center my-3">
					<div className="col-auto pe-0">
						<div className="text-dark small text-center">
							<ArrowRight />
						</div>
					</div>
					<div className="col-auto small">{label}</div>
				</div>
			</GroupLink>
		</section>
	);
};

ReadMoreLink.propTypes = {
	article_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	groups: PropTypes.array,
	label: PropTypes.string,
	marker_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	page: PropTypes.string,
	product_brand_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	product_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	slug: PropTypes.string,
};

export default ReadMoreLink;
